'use client';

import { useTheme } from '@/providers/theme-provider';
import { Moon, Sun } from 'lucide-react';
import { useEffect, useState } from 'react';

export const ThemeToggle = ({ className = '' }: { className?: string }) => {
  const { theme, toggleTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return (
      <div
        className={`h-10 w-10 sm:h-9 sm:w-9 animate-pulse rounded-xl bg-surface-container-high ${className}`}
      />
    );
  }

  const isDark = theme === 'dark';
  const label = isDark ? 'Switch to light theme' : 'Switch to dark theme';

  return (
    <button
      onClick={toggleTheme}
      type="button"
      className={`relative flex h-10 w-10 sm:h-9 sm:w-9 items-center justify-center overflow-hidden rounded-xl border transition-all duration-200 active:scale-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-pb-blue-500 focus-visible:ring-offset-2 dark:focus-visible:ring-offset-[#070b14] cursor-pointer ${
        isDark
          ? 'border-pb-slate-700/80 bg-pb-slate-900/90 text-amber-400 hover:border-pb-slate-600 hover:bg-pb-slate-800 hover:text-amber-300'
          : 'border-pb-slate-200 bg-pb-white text-pb-slate-600 hover:border-pb-slate-300 hover:bg-pb-slate-50 hover:text-pb-slate-900 shadow-xs'
      } ${className}`}
      aria-label={label}
      title={label}
    >
      <div className="relative flex items-center justify-center">
        <div
          className={`transition-all duration-300 ease-in-out ${
            isDark
              ? 'scale-0 opacity-0 -rotate-90 pointer-events-none absolute'
              : 'scale-100 opacity-100 rotate-0 text-amber-500'
          }`}
        >
          <Sun size={19} />
        </div>

        <div
          className={`transition-all duration-300 ease-in-out ${
            isDark
              ? 'scale-100 opacity-100 rotate-0 text-blue-400'
              : 'scale-0 opacity-0 rotate-90 pointer-events-none absolute'
          }`}
        >
          <Moon size={19} />
        </div>
      </div>
    </button>
  );
};
